export const LOCAL_STORAGE_KEY = 'grsf-referral-code';
